import { Component, OnInit, ViewChild } from '@angular/core';

import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

import { AutoLeap } from 'app/constants/autoleap.constants';
import { EmailTemplate } from 'app/constants/csv/email-template-column';
import { campaignTypes, emailTemplateTypes, marketingBasicTags, marketingTemplateTypes } from 'app/constants/marketing.constants';
import { DataService, HelperService, HTTPService, ValidationService } from 'app/services';

import { EmailEditorComponent } from 'angular-email-editor';
import { SendPreviewTemplate } from 'app/modules/marketing/components/send-template-view/send-template-view.component';

@Component({
  selector: 'announcement-template-view',
  templateUrl: './announcement-template-view.component.html',
  styleUrls: ['./announcement-template-view.component.scss'],
  providers: [DialogService],
})
export class AnnouncementTemplateView implements OnInit {
  @ViewChild('editor') emailEditor: EmailEditorComponent;
  JsonParse;
  options = {
    form: {
      enabled: true,
    },
  };
  ref: DynamicDialogRef;
  errors: any = {};
  templateAnnouncement;
  templateText;
  htmlContentAnnouncment;
  MARKETING_ANN = 'MARKETING_ANN';
  routeSubscription: any;
  templateName = '';
  temlpateId = null;
  template = {
    campaignType: '',
    name: '',
    followUpEvent: null,
    subject: '',
    templateType: '',
    text: '',
    htmlTemplateJson: '',
    htmlContents: '',
    emailTemplateType: '',
    email: '',
  };
  isLoading = false;
  company: any = {};
  isOpenedFromCampaign;
  htmlTemplateJson;
  htmlContents;
  isUpdateMasterTemplate: boolean = false;
  isSending: boolean = false;

  constructor(
    private httpService: HTTPService,
    private helperService: HelperService,
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig,
    private dataService: DataService,
    private dialogService: DialogService,
    private validationService: ValidationService
  ) {}

  ngOnInit() {
    this.company = this.dialogConfig.data ? this.dialogConfig.data.companyDetails : null;
    this.temlpateId = this.dialogConfig.data ? this.dialogConfig.data.templateId : null;
    const { isOpenedFromCampaign, htmlTemplateJson, campaignType, htmlContents } = this.dialogConfig.data;
    this.htmlTemplateJson = htmlTemplateJson;
    this.htmlContents = htmlContents;
    this.template.campaignType = campaignType;
    this.isOpenedFromCampaign = isOpenedFromCampaign;
    this.temlpateId ? this.getTemplateById() : this.getAnnouncementTemplate(this.MARKETING_ANN);
  }

  closeDialog(isSuccess: boolean = false, data: any = {}) {
    this.dialogRef.close({ isSuccess, data });
  }

  private validate(checkEmail: boolean = false): boolean {
    let isValid: boolean = true;

    this.errors = {};

    if (!this.template.name) {
      this.errors.name = 'Template name is required';
      isValid = false;
    }
    if (!this.template.subject) {
      this.errors.subject = 'Template subject is required';
      isValid = false;
    }
    if (checkEmail && this.template.email && !this.validationService.validateEmail(this.template.email)) {
      this.errors.email = 'Email is not valid';
      isValid = false;
    }
    return isValid;
  }

  parseTemplate(template: any = '') {
    const { userName = '' } = this.helperService.getCompany();
    const [firstName, ...lastNames] = userName.split(' ');
    const lastName = lastNames.join(' ');
    const companyName = this.company?.name;
    const companyPhone = this.company?.phone;
    const companyColor = this.company.color;
    const addLine1 = this.company.address.addLine1;
    const city = this.company.address.city;
    const state = this.company.address.state;
    const location = this.company.location;

    if (template) {
      template = template.replaceAll(new RegExp('\\[company_name\\]', 'g'), companyName);
      template = template.replaceAll(new RegExp('\\[company_phone\\]', 'g'), companyPhone);
      template = template.replaceAll(new RegExp('\\[company_address_1\\]', 'g'), this.company.address ? `${addLine1}, ${city}, ${state}` : null);
      template = template.replaceAll(new RegExp('\\[company_location\\]', 'g'), location || 'Add Google Map Link');
      template = template.replaceAll(new RegExp('\\[\\[CUSTOMER_FIRST_NAME\\]\\]', 'g'), firstName);
      template = template.replaceAll(new RegExp('\\[\\[CUSTOMER_LAST_NAME\\]\\]', 'g'), lastName);
      template = template.replaceAll(new RegExp('\\[\\[SHOP_NAME\\]\\]', 'g'), companyName);
      template = template.replaceAll(new RegExp('\\[\\[SHOP_CONTACT_NUMBER\\]\\]', 'g'), companyPhone);
    }

    return template;
  }

  parseTags(text: any = '', parse: any) {
    if (!text) return;

    if (!parse) {
      text = text.replaceAll('[[', `&#91;&#91;`);
      text = text.replaceAll(']]', `&#93;&#93;`);
      return text;
    } else {
      text = text.replaceAll('&#91;&#91;', `[[`);
      text = text.replaceAll('&#93;&#93;', `]]`);
      return text;
    }
  }

  parseFooter(text: any = '') {
    if (!text) return;

    text = text.replaceAll(EmailTemplate.customFooterTemplate, `[template_html_footer]`);
    return text;
  }

  getTemplateById() {
    this.httpService.getSingleMarketingTemplates(this.temlpateId).then((template: any) => {
      this.templateAnnouncement = template;
      this.template = {
        ...this.template,
        name: this.templateAnnouncement.name,
        text: this.templateAnnouncement.text ? this.templateAnnouncement.text : ' ',
        subject: this.templateAnnouncement.subject,
        campaignType: this.templateAnnouncement.campaignType,
      };
      if (this.templateAnnouncement && this.templateAnnouncement.htmlTemplateJson) {
        if (this.htmlTemplateJson) this.JsonParse = JSON.parse(this.htmlTemplateJson);
        else this.JsonParse = JSON.parse(this.templateAnnouncement.htmlTemplateJson);
        if (this.JsonParse && this.JsonParse.body && this.JsonParse.body.rows) {
          this.JsonParse.body.rows.map((x) => {
            x.columns.map((y) => {
              y.contents.map((z) => {
                if (z.values._meta.htmlID == EmailTemplate.companyFooter) {
                  z.values.text = EmailTemplate.customFooterTemplate;
                  z.values.text = z.values.text.replaceAll('[company_color]', 'black !important');
                }
                if (z.values && z.values.text && z.values._meta.htmlClassNames != EmailTemplate.u_content_heading) {
                  z.values.text = this.parseTags(z.values.text, false);
                }
              });
            });
          });
        }
        if (this.emailEditor.editor && this.emailEditor.editor.init) {
          this.loadTemplate();
        } else {
          setTimeout(() => {
            this.loadTemplate();
          }, 2000);
        }
      }
    });
  }

  handleChange(type, e: any): void {
    this.errors[type] = '';
    this.template[type] = e;
  }

  save() {
    if (!this.validate() || this.isLoading) return;
    this.isLoading = true;

    let StringifyData;
    this.emailEditor.editor.exportHtml((data) => {
      this.htmlContentAnnouncment = data;
      this.htmlContentAnnouncment.html = this.parseFooter(this.htmlContentAnnouncment.html);
      if (data.design && data.design.body && data.design.body.rows) {
        data.design.body.rows.map((x) => {
          x.columns.map((y) => {
            y.contents.map((z) => {
              if (z.values._meta.htmlID == EmailTemplate.companyFooter) {
                z.values.text = EmailTemplate.footerReverseTemplate;
              }
              if (z.values && z.values.text) {
                z.values.text = this.parseTags(z.values.text, false);
              }
            });
          });
        });
      }
      StringifyData = JSON.stringify(data.design);
    });

    this.emailEditor.editor.exportPlainText((data) => {
      this.templateText = data.text;
    });
    setTimeout(() => {
      this.template = {
        campaignType: campaignTypes.PROMOTIONAL,
        emailTemplateType: emailTemplateTypes.ANNOUNCEMENT,
        name: this.template.name,
        followUpEvent: null,
        subject: this.template.subject,
        templateType: marketingTemplateTypes.EMAIL,
        text: this.templateText ? this.templateText : ' ',
        htmlTemplateJson: StringifyData,
        htmlContents: this.htmlContentAnnouncment.html,
        email: this.template.email,
      };
      // Don't make the update call if user want's to update the template locally
      if (this.isOpenedFromCampaign && !this.isUpdateMasterTemplate) {
        this.closeDialog(true, { ...this.template });
        return;
      }
      if (this.temlpateId) {
        this.httpService.updateMarketingTemplates(this.temlpateId, this.template).then((x) => {
          this.isLoading = false;
          this.helperService.showToaster('success', 'Template successfully updated');
          this.closeDialog(true, { ...this.template });
          return;
        });
      } else {
        this.httpService.createMarketingTemplates(this.template).then((x) => {
          this.isLoading = false;
          this.helperService.showToaster('success', 'Template successfully updated');
          this.dataService.sendData(this.dataService.typePassData('campaign-template-list', {}));
          this.closeDialog(true, { ...this.template });
          return;
        });
      }
    }, 2000);
  }

  loadTemplate() {
    this.emailEditor.editor.init({
      id: 'announcement-template',
      displayMode: 'email',
      projectId: 53536,
      customCSS: [EmailTemplate.announcementCss],
      customJS: [EmailTemplate.productCustomJss],
      editor: {
        minRows: 2,
        maxRows: 3,
      },
      fonts: {
        showDefaultFonts: false,
        customFonts: EmailTemplate.fonts,
      },
      mergeTagsConfig: {
        autocompleteTriggerChar: '@',
      },
      mergeTags: {
        customer_tags: {
          name: 'Customer Tags',
          mergeTags: {
            first_name: {
              name: 'First Name',
              value: marketingBasicTags.customerFirstName,
              sample: marketingBasicTags.customerFirstName,
            },
            last_name: {
              name: 'Last Name',
              value: marketingBasicTags.customerLastName,
              sample: marketingBasicTags.customerLastName,
            },
          },
        },
        shop_tags: {
          name: 'Shop Tags',
          mergeTags: {
            shop_name: {
              name: 'Shop Name',
              value: marketingBasicTags.shopName,
              sample: marketingBasicTags.shopName,
            },
            contact_number: {
              name: 'Contact Number',
              value: marketingBasicTags.contactNumber,
              sample: marketingBasicTags.contactNumber,
            },
          },
        },
      },
      tabs: {
        audit: {
          enabled: false,
        },
        blocks: {
          enabled: false,
        },
        body: {
          enabled: false,
        },
        content: {
          enabled: true,
        },
        images: {
          enabled: false,
        },
      },
      tools: {
        form: {
          enabled: false,
        },
        heading: {
          enabled: false,
        },
        menu: {
          enabled: false,
        },
        divider: {
          enabled: false,
        },
        button: {
          enabled: true,
          properties: {
            buttonColors: {
              value: {
                color: '#FFFFFF',
                backgroundColor: '#b84140',
                hoverColor: '#FFFFFF',
                hoverBackgroundColor: '#3AAEE0',
              },
            },

            text: {
              value: '<span style="font-size: 24px; line-height: 28.8px;">Button Text</span>',
            },
          },
        },
        image: {
          enabled: false,
          properties: {
            containerPadding: {
              enabled: false,
            },
          },
        },
        html: {
          enabled: false,
        },
        text: {
          enabled: false,
          usageLimit: 1,
        },
      },
      appearance: {
        panels: {
          tools: {
            collapsible: true,
          },
        },
      },
      features: {
        textEditor: {
          spellChecker: true,
          tables: false,
          cleanPaste: false,
          emojis: false,
          preheaderText: false,
        },
      },
    });
    this.emailEditor.editor.setLinkTypes([
      {
        name: "appointment_code",
        label: "Appointment Link",
        attrs: {
          href: "[[APPOINTMENT_REQ_LINK]]",
          target: "_blank"
        },
        fields: [
          {
            name: 'text',
            label: 'URL',
            defaultValue: '[[APPOINTMENT_REQ_LINK]]',
            inputType: 'text',
            placeholderText: null,
            options: [],
          },
        ]
      },
      {
        name: 'email',
        enabled: false,
      },
      {
        name: 'sms',
        enabled: false,
      },
    ]);
    this.emailEditor.editor.addEventListener('design:updated', (data) => {
      this.templateJsonUpdate(data);
    });
    this.emailEditor.editor.loadDesign(this.JsonParse);
    document.getElementById('announcement-template').querySelector('iframe').style.display = 'none';
  }

  getAnnouncementTemplate(template?) {
    this.httpService.getEmailTemplatesByType(template).then((res: any) => {
      this.templateAnnouncement = res;

      if (this.templateAnnouncement && this.templateAnnouncement.templateJson) {
        this.JsonParse = JSON.parse(this.templateAnnouncement.templateJson);
        if (this.JsonParse && this.JsonParse.body && this.JsonParse.body.rows) {
          this.JsonParse.body.rows.map((x) => {
            x.columns.map((y) => {
              y.contents.map((z) => {
                // Here we update image in template
                if (z.values._meta.htmlID == EmailTemplate.logoId) {
                  z.values.src.url = this.company.logo;
                }
                // Here we updat information tags in template
                if (z.values.text) {
                  z.values.text = this.parseTemplate(z.values.text);
                }
                // Here we update phone number tags in template
                if (z.values.href && z.values.href.values && z.values.href.values.phone) {
                  z.values.href.values.phone = this.company.phone;
                }
                // Here we update footer tags in template
                if (z.values._meta.htmlID == EmailTemplate.companyFooter) {
                  z.values.text = EmailTemplate.customFooterTemplate;
                  z.values.text = z.values.text.replaceAll('[company_color]', 'black !important');
                }
                // Here we update email tags in template
                if (z.values._meta.htmlID == EmailTemplate.companyLink) {
                  z.values.href.values.href = this.company.website;
                }
              });
            });
          });
        }
        if (this.emailEditor.editor && this.emailEditor.editor.init) {
          this.loadTemplate();
        } else {
          setTimeout(() => {
            this.loadTemplate();
          }, 2000);
        }
      }
    });
  }

  sendPreviewEmail(): void {
    if (!this.validate() || this.isLoading) return;
    let StringifyData;
    this.isSending = true;
    this.emailEditor.editor.exportHtml((x) => {
      this.htmlContentAnnouncment = x;
      this.htmlContentAnnouncment.html = this.parseTags(this.htmlContentAnnouncment.html, true);
      this.htmlContentAnnouncment.html = this.parseTemplate(this.htmlContentAnnouncment.html);
      // this.htmlContentAnnouncment.html = this.parseFooter(this.htmlContentAnnouncment.html);
      StringifyData = JSON.stringify(x.design);
    });
    this.emailEditor.editor.exportPlainText((y) => {
      this.templateText = y.text;
    });
    setTimeout(() => {
      this.template = {
        campaignType: campaignTypes.PROMOTIONAL,
        emailTemplateType: emailTemplateTypes.ANNOUNCEMENT,
        name: this.template.name,
        followUpEvent: null,
        subject: this.template.subject,
        templateType: marketingTemplateTypes.EMAIL,
        text: this.templateText ? this.templateText : ' ',
        htmlTemplateJson: StringifyData,
        htmlContents: this.htmlContentAnnouncment.html,
        email: this.template.email,
      };

      const template = { ...this.template };
      const ref = this.dialogService.open(SendPreviewTemplate, {
        styleClass: 'add-dialog mkt-send-template-dialog',
        showHeader: false,
        data: { template },
      });
      const onClose = ref.onClose.subscribe(({ isSuccess }) => {
        this.isSending = false;
        onClose.unsubscribe();
      });
      this.isSending = false;
    }, 2000);
  }

  templateJsonUpdate(data) {
    if (data.type == 'content:added' || data.type == 'content:removed') {
      this.emailEditor.editor.saveDesign((datas) => {
        datas.body.rows &&
          datas.body.rows.map((a) => {
            if (a.values._meta.htmlID == EmailTemplate.announcementColumn.announcement_col_first) {
              a.columns &&
                a.columns.map((y, i) => {
                  y.contents &&
                    y.contents.map((z) => {
                      if (z.type == 'button') {
                        if (y.contents.length > 1) {
                          y.contents.shift();
                        }
                      }
                    });
                  if (a.columns.length > 1 && y.contents.length == 0) {
                    a.columns.splice(i, 1);
                    a.cells.splice(i, 1);
                  }
                });
            }
          });
        this.emailEditor.editor.loadDesign(datas);
      });
    }
  }
}
